<button
  class="upgrade-btn-btn"
  extended
  mat-flat-button
  routerLinkActive="router-link-active"
  [color]="_color"
  [ngClass]="{
    'n-one-btn': _hasBorder,
    'n-one-selected': _selected,
    'upgrade-btn-light': _isLightTheme,
    'upgrade-btn-dark': _isDarkTheme,
    'upgrade-btn-paper': _isPaperTheme,
  }"
  [routerLink]="[_dynamicRoute]"
>
  <mat-icon class="material-icons-outlined">{{ _icon }}</mat-icon>
  {{ _label }}
</button>
